import { useState } from 'react'
import { createFileRoute } from '@tanstack/react-router'

import { validateUserAddPermission } from "@/lib/api/auth"
import { Button } from "@/components/ui/button"
import {
  Credenza,
  CredenzaBody,
  CredenzaContent,
} from '@/components/ui/credenza'
import ZonesPolicyForm from '@/components/forms/zones-policy-due-date-form'
import { Icons } from '@/components/icons'

export const Route = createFileRoute(
  '/_home/zone-settings/zone-policy-due-date/add',
)({
  component: AddZonePolicyPage,
})

export default function AddZonePolicyPage() {
  const [showModal, setShowModal] = useState(false)

  return (
    <main>
      <div className="flex w-full justify-end">
        <Button
          onClick={() => {
            if (!validateUserAddPermission()) return
            setShowModal(true)
          }}
        >
          <Icons.add className="size-4" />
          Add Policy Due Date
        </Button>
      </div>
      <Credenza open={showModal} onOpenChange={setShowModal}>
        <CredenzaContent className="overflow-auto md:max-h-[750px] md:max-w-[750px]">
          <CredenzaBody className="max-h-full max-w-full">
            <ZonesPolicyForm setShowModal={setShowModal} />
          </CredenzaBody>
        </CredenzaContent>
      </Credenza>
    </main>
  )
}
